interface Schemas {
  request_schema: Record<string, string> | null;
  response_schema: Record<string, string> | null;
}

export const deploymentSchemaToPreview = (state?: any, schemas?: Schemas) => {
  const responseSchema = Object.entries(schemas?.response_schema || {}).map(([fieldName, variableId]) => {
    return {
      fieldName,
      variableName: state?.variables?.[variableId].name || "",
      type: "text" as const,
    };
  });

  const requestSchema = Object.entries(schemas?.request_schema || {}).map(([fieldName, variableId]) => {
    return {
      fieldName,
      variableName: state?.variables?.[variableId].name || "",
      type: "text" as const,
    };
  });

  return {
    requestSchema,
    responseSchema,
  };
};
